import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { initAnalytics } from '@/analytics';

import { App } from './App';
// Self-hosted Inter so every reviewer sees the same font, without a third-party font request.
import '@fontsource-variable/inter';
import './index.css';
import { reloadOnceOnPreloadError } from '@/lib/newBuild';

initAnalytics();
// Preview age gate runs after React mounts (DialogGlobalComponent) so it can use auditor dialogs.
window.addEventListener('vite:preloadError', reloadOnceOnPreloadError());

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
